import { CLERK_PUBLISHABLE_KEY } from './config'

// Lazily load the Clerk SDK to avoid bundling the entire library in the
// initial application chunk. This helps keep the initial page load smaller.
let clerkInstance: any | null = null
let cachedPublishableKey: string | null = null

async function fetchClerkPublishableKey(): Promise<string> {
  if (cachedPublishableKey) return cachedPublishableKey

  // Prefer an explicit build-time override for local/dev if provided.
  if (CLERK_PUBLISHABLE_KEY) {
    cachedPublishableKey = CLERK_PUBLISHABLE_KEY
    return cachedPublishableKey
  }

  const resp = await fetch('/api/security/clerk-config', {
    method: 'GET',
  })
  if (!resp.ok) {
    throw new Error(`Failed to fetch Clerk config: ${resp.status} ${resp.statusText}`)
  }

  const json = await resp.json()
  if (!json?.clerk_publishable_key) {
    throw new Error('Clerk config response missing clerk_publishable_key')
  }

  cachedPublishableKey = json.clerk_publishable_key
  return cachedPublishableKey
}

export async function getClerk() {
  if (clerkInstance) return clerkInstance
  const { Clerk } = await import('@clerk/clerk-js')
  const key = await fetchClerkPublishableKey()
  clerkInstance = new Clerk(key)
  return clerkInstance
}
